import { Tooltip, Typography } from "@mui/material";
import { isNull } from "lodash";
import React from "react";

const EllipsisInfoLabel = ({ title, content, maxChar = 'none'}) => {
  return (
    (!(isNull(title) || typeof(title)=="undefined")) && <Typography sx={{ fontSize: "14px", lineHeight: "24px" ,display:"flex",gap:0.5,alignItems:"center"}}>
      <div
        style={{
          fontFamily: "Roboto regular, Helvetica, Arial, sans-serif",
          fontWeight: "400",
          whiteSpace:'nowrap'
        }}
      >
        {title}
      </div> 
      <div
        style={{
          fontFamily: "Roboto medium, Helvetica, Arial, sans-serif",
          fontWeight: "500",
          maxWidth:  maxChar == 'none' ? 'none' : `${maxChar}ch`,
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}
      >
        <Tooltip title= {(isNull(content) || typeof(content)=="undefined") ? "None" : content} arrow >
          {(isNull(content) || typeof(content)=="undefined") ? "None" : content}
        </Tooltip>
      </div>
    </Typography>
  );
};

export default EllipsisInfoLabel;
